/**
 * @generated SignedSource<<c42790cbfa2262abea47bff43f9a722e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkShareButton_pixQrCode$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly projectType: string | null | undefined;
  } | null | undefined;
  readonly paymentLinkUrl: string | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentLinkShareButton_pixQrCode";
};
export type PaymentLinkShareButton_pixQrCode$key = {
  readonly " $data"?: PaymentLinkShareButton_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkShareButton_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkShareButton_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentLinkUrl",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "fa83b57a5cc6904a6d2a63bed23f3551";

export default node;
